import React from 'react';
import ButtonBase from '../../Buttons/ButtonBase';
import { Link as LinkScroll } from 'react-scroll';
import './CardEsp.scss'

const CardEsp = ({specialties, quotation}) => {
    return ( 
        <>
             <section className="exp">
                <p className="exp_title">Especialidades/Servicios</p>
                <article className="cardExp">
                    <header className="cardExp_header">

                    <div className="cardExp_espe">
                        <ul>
                            {specialties && specialties.map((specialty, index) => {
                                return (
                                    <li key={index} className="cardExp_elem">{specialty}</li>
                                );
                            })}
                        </ul>
                    </div>


                    </header>
                   {quotation && <LinkScroll to='contactForm' smooth={true}>
                    <ButtonBase variant="primary" style={{marginTop: 24}}>Solicitar cotización</ButtonBase>
                   </LinkScroll>}
                    
                </article>
               
            </section>

        </>
     );
}
 
export default CardEsp;